module.exports = __webpack_public_path__ + "img/14.45e12d2c.png";